import { Row, Col, Image, Button } from 'react-bootstrap';


function LeftHero({title, teaser, image, buttonLink, buttonText}) {
    const ButtonArea = () => {
        if(buttonLink) {
            return (
                <div className='d-grid gap-2 justify-content-md-center px-2 '>
                    <Button className='btn btn-outline-secondary btn-lg px-4' href={buttonLink}>{buttonText}</Button>
                </div>
            )
        }
        return null;
    };

    return (
        <Row className='flex-lg-row-reverse align-items-center g-4 man-hero text-center'>
            <Col className='col-10 col-sm-8 col-lg-6 hero-image'>
                <Image src={image} className='d-block img-fluid'/>
            </Col>
            <Col lg={6} className='teaser-text px-2'>
                <h1 className='display-5 fw-bold lh-1 mb-3'>{title}</h1>
                <p className='lead' dangerouslySetInnerHTML={{__html: teaser}}></p>

                <ButtonArea />
            </Col>
        </Row>
    );
}

export default LeftHero;